<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__warn">
      {{ 'PRODUCT_SUBCATEGORY.DELETE_CONFIRM_TITLE' | translate }}
    </h3>
    <p
      class="sp-color__primary sp-margin__top sp-margin__bottom-x4"
      [innerHTML]="'PRODUCT_SUBCATEGORY.DELETE_CONFIRM_MESSAGE' | translate : { name: subcategory?.name }"></p>

    <div class="sp-row__align sp-grid__gap sp-margin__top-x2">
      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__warn'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.YES_LABEL'"
        [is_disabled]="is_delete_running"
        [is_spinner_visible]="is_delete_running"
        (click)="onDeleteClick()"></app-shared-button>

      <button
        (click)="onCloseClick()"
        mat-button
        class="sp-button sp-button__plain sp-width__full"
        [disabled]="is_delete_running">
        {{ 'GENERAL.NO_LABEL' | translate }}
      </button>
    </div>
  </div>
</div>
